/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentRedistributionRequest
 */
export interface DocumentRedistributionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentRedistributionRequest
     */
    idList?: Array<string>;
}

/**
 * Check if a given object implements the DocumentRedistributionRequest interface.
 */
export function instanceOfDocumentRedistributionRequest(value: object): value is DocumentRedistributionRequest {
    return true;
}

export function DocumentRedistributionRequestFromJSON(json: any): DocumentRedistributionRequest {
    return DocumentRedistributionRequestFromJSONTyped(json, false);
}

export function DocumentRedistributionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentRedistributionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'idList': json['idList'] == null ? undefined : json['idList'],
    };
}

export function DocumentRedistributionRequestToJSON(json: any): DocumentRedistributionRequest {
    return DocumentRedistributionRequestToJSONTyped(json, false);
}

export function DocumentRedistributionRequestToJSONTyped(value?: DocumentRedistributionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idList': value['idList'],
    };
}

